/**
 * User-Agent からモバイル OS を判定するユーティリティ。
 * userAgent を明示的に渡せば副作用のない純関数として評価でき（テストや Server Component の
 * headers 由来 UA 向け）、省略時はブラウザの `navigator.userAgent` を読む（環境依存・SSR では空文字）。
 *
 * 用途は UX 最適化（アプリストアの出し分け・端末別レイアウト調整など）に限定する。
 * UA は DevTools 等で偽装できるため、認証・認可などセキュリティ判定には使わない。
 * また iPadOS 13+ の Safari は Mac と同一の UA を送るため、サーバーサイド（UA だけ）では
 * iPad と Mac を区別できず 'other' になる。iPad の判別が必須ならクライアントで
 * `navigator.maxTouchPoints` / touch イベントの併用が要る。
 */
export type MobileOs = 'ios' | 'android' | 'other';

const readCurrentUserAgent = (): string => (typeof navigator !== 'undefined' ? navigator.userAgent : '');

export function getMobileOs(userAgent: string = readCurrentUserAgent()): MobileOs {
  if (/iPhone|iPod|iPad/i.test(userAgent)) return 'ios';
  if (/Android/i.test(userAgent)) return 'android';
  return 'other';
}

export function isAndroid(userAgent: string = readCurrentUserAgent()): boolean {
  return /Android/i.test(userAgent);
}

export function isIos(userAgent: string = readCurrentUserAgent()): boolean {
  return /iPhone|iPod|iPad/i.test(userAgent);
}
